import Vue from 'vue';
import Router from 'vue-router';
import AppHomePage from './components/AppHomePage';
import AppTeamPage from './components/AppTeamPage';
import AppTeamDetail from './components/AppTeamDetail';
import AppImpact from './components/AppImpact';
import AppNews from './components/AppNews';
import AppImpactDetail from './components/AppImpactDetail';
import AppNewsDetail from './components/AppNewsDetail';
import AppContact from './components/AppContact';

/*global wpData:true*/
/*eslint no-undef: "error"*/
const appPath = `/${wpData.app_path}`;

Vue.use( Router );

/**
 * Each route should map to a component.
 * The "component" can either be an actual component or just a component options object.
 */
export default new Router({
	base: appPath, // path of the SPA relative to the domain.
	mode: 'hash', // or "history"
	routes: [
		{
			path: '/',
			name: 'AppHomePage',
			component: AppHomePage
        },
        {
			path: '/impact',
			name: 'AppImpact',
            component: AppImpact,
            meta: {transitionName: 'slide-up'},
            props: (route) =>({query: route.query.q})
        },
        {
			path: '/impact/:id',
			name: 'AppImpactDetail',
            component: AppImpactDetail,
            meta: {transitionName: 'slide-up'},
            props: true
		},
		{
			path: '/news',
			name: 'AppNews',
            component: AppNews,
            meta: {transitionName: 'slide-up'}
        },
        {
			path: '/news/:id',
			name: 'AppNewsDetail',
            component: AppNewsDetail,
            meta: {transitionName: 'fade'},
            props: true
		},
        {
			path: '/team',
			name: 'AppTeamPage',
            component: AppTeamPage,
            meta: {transitionName: 'slide-up'}
        },
        {
			path: '/team/:id',
			name: 'AppTeamDetail',
            component: AppTeamDetail,
            meta: {transitionName: 'slide-up'}
        },
        {
			path: '/contact',
			name: 'AppContact',
            component: AppContact,
            meta: {transitionName: 'slide-up'}
        },
	]
});


// WEBPACK FOOTER //
// ./src/app-routes.js